import PropTypes from "prop-types";
import React from "react";
import { useHistory } from "react-router-dom";

import { Segment } from "semantic-ui-react";

import NewEditFieldForm from "./newFieldForm";

const NewEditField = ({
	mode,
	setModeState,
	setFieldId,
	fieldId,
	fromViewer,
	handleCancel,
	onFieldConfigSaved,
	navigateToNextStep,
	navigateToExpDesigns,
	handleDeleteField,
	isDeleting,
	isFieldScaleTrial,
}) => {
	const history = useHistory();

	function handleSave(fieldSaveResponse, isFieldScale) {
		if (fieldSaveResponse) {
			if (!fromViewer) {
				history.push(`/fields/${fieldSaveResponse.fieldId}/edit`, { isFieldScaleTrial: isFieldScale });
			}
		}
	}

	return !fieldId && mode === "edit" ? (
		<Segment basic>
			<Segment basic>
				<p>{"This field could not be found."}</p>
			</Segment>
		</Segment>
	) : (
		<NewEditFieldForm
			setFieldId={(id) => setFieldId(id)}
			fieldId={fieldId}
			fromViewer={fromViewer}
			handleCancel={() => handleCancel()}
			handleSave={(res, isFieldScale) => handleSave(res, isFieldScale)}
			onFieldConfigSaved={onFieldConfigSaved}
			navigateToNextStep={navigateToNextStep}
			navigateToExpDesigns={navigateToExpDesigns}
			setModeState={(m) => setModeState(m)}
			mode={mode}
			handleDeleteField={handleDeleteField}
			isDeleting={isDeleting}
			isFieldScaleTrial={isFieldScaleTrial}
		/>
	);
};

NewEditField.propTypes = {
	mode: PropTypes.string.isRequired,
	setModeState: PropTypes.func,
	setFieldId: PropTypes.func,
	fieldId: PropTypes.string,
	fromViewer: PropTypes.bool,
	handleCancel: PropTypes.func,
	onFieldConfigSaved: PropTypes.func,
	navigateToNextStep: PropTypes.func,
	navigateToExpDesigns: PropTypes.func,
	handleDeleteField: PropTypes.func,
	isDeleting: PropTypes.bool,
	isFieldScaleTrial: PropTypes.bool,
};

export default NewEditField;
